//@flow
import TrackJs from './trackjs-interface';
import Heap from './heap-interface';

export default {
  activate() {
    try {
      if (global.inServer || !global.optimizely) return;
      _addListener();
      global.optimizely.push({
        type: 'activate',
      });
    } catch(e) {
      TrackJs.console.debug(`error: ${e}`);
      TrackJs.track(`Error activating optimizely`);
    }
  },
};

let _listening;

function _addListener() {
  if (_listening) return;

  global.optimizely.push({
    type: 'addListener',
    filter: {
      type: 'lifecycle',
      name: 'activated',
    },
    handler: _syncWithHeapAndTrackjs,
  });

  _listening = true;
}

function _syncWithHeapAndTrackjs() {
  const props = {};
  const state = global.optimizely.get('state');

  const activeExperimentsIds = state.getActiveExperimentIds();
  const experiments = state.getExperimentStates();

  activeExperimentsIds.forEach((id) => {
    const experiment = experiments[id];
    props[experiment.experimentName] = experiment.variation.name;
    TrackJs.addMetadata(experiment.experimentName, experiment.variation.name);
  });

  Heap.addUserProperties(props);
}
